"use strict";
exports.__esModule = true;
exports.tokenIsListedOnLedger = exports.toSubAccMint = exports.toTokenMint = exports.toTokenId = exports.decodeAccountIdWithTokenAccountAddress = exports.encodeAccountIdWithTokenAccountAddress = exports.isEd25519Address = exports.isValidBase58Address = exports.MAX_MEMO_LENGTH = void 0;
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var web3_js_1 = require("@solana/web3.js");
exports.MAX_MEMO_LENGTH = 500;
var isValidBase58Address = function (address) {
    try {
        return Boolean(new web3_js_1.PublicKey(address));
    }
    catch (_) {
        return false;
    }
};
exports.isValidBase58Address = isValidBase58Address;
var isEd25519Address = function (address) {
    return web3_js_1.PublicKey.isOnCurve(new web3_js_1.PublicKey(address).toBytes());
};
exports.isEd25519Address = isEd25519Address;
function encodeAccountIdWithTokenAccountAddress(accountId, address) {
    return "".concat(accountId, "+").concat(address);
}
exports.encodeAccountIdWithTokenAccountAddress = encodeAccountIdWithTokenAccountAddress;
function decodeAccountIdWithTokenAccountAddress(accountIdWithTokenAccountAddress) {
    var lastColonIndex = accountIdWithTokenAccountAddress.lastIndexOf("+");
    return {
        accountId: accountIdWithTokenAccountAddress.slice(0, lastColonIndex),
        address: accountIdWithTokenAccountAddress.slice(lastColonIndex + 1)
    };
}
exports.decodeAccountIdWithTokenAccountAddress = decodeAccountIdWithTokenAccountAddress;
function toTokenId(mint) {
    return "solana/spl/".concat(mint);
}
exports.toTokenId = toTokenId;
function toTokenMint(tokenId) {
    return tokenId.split("/")[2];
}
exports.toTokenMint = toTokenMint;
function toSubAccMint(subAcc) {
    return toTokenMint(subAcc.token.id);
}
exports.toSubAccMint = toSubAccMint;
function tokenIsListedOnLedger(mint) {
    var _a;
    return ((_a = (0, cryptoassets_1.findTokenById)(toTokenId(mint))) === null || _a === void 0 ? void 0 : _a.type) === "TokenCurrency";
}
exports.tokenIsListedOnLedger = tokenIsListedOnLedger;
//# sourceMappingURL=logic.js.map